function compactItemVerticalBorder(token, parentCls, prefixCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal(),
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2,
        },
        '&-item': {
            '&:focus,&:active': {
                zIndex: 3,
            },
            '&:hover': {
                zIndex: 4,
            },
            '&[disabled]': {
                zIndex: 0,
            },
        },
    };
}
function compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0,
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0,
            },
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0,
            },
        },
    };
}
export function genCompactItemVerticalStyle(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: {
            ...compactItemVerticalBorder(token, compactCls, token.componentCls),
            ...compactItemBorderVerticalRadius(token.componentCls, compactCls),
        },
    };
}
